export const links = {
  facebook: "",
  twitter: "",
  instagram: "https://www.instagram.com/rosie_thebatdog",
  linkedin: "",
};
